import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

function StudentPayment() {
    const [Fee, setFee] = useState(1625)
    const dispatch = useDispatch();
    const history = useHistory();
    const [Type, setType] = useState("")
    const [stfee,setStfee]=useState("")
  

    useEffect(() => {
        const result = JSON.parse(localStorage.getItem("result"))
        const result2 = JSON.parse(localStorage.getItem("type"))
        setStfee(result2)
        setType(result2)
        if (result2 === 'student') {
            setFee(500); 
        }
        else if (result2==='single'){
            setFee(1125)
        }
        else{
            setFee(result)

        }
    })

    const handleRegister = () => {
        dispatch({ type: "SET_FORM_TYPE", payload: Type });
        dispatch({ type: "SET_FORM_FEE", payload: Fee });
        history.push('/MembershipFormVedio')
    }

    return (
        <div className="appHome">
            <h1 className="appHomeHeader">NMO Members Fees Details</h1>
            <div style={{ textAlign: 'center', height: 'auto', display: 'flex', flexDirection: 'column', gap: "30px", width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: "30px", width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="quesCon">
                        {Fee > 0 &&
                            <div className="priceDetail">
                                <h3 style={{ background: '#fc0101', color: 'white', padding: '10px 0', borderRadius: '8px' }}>You Need to Pay ₹ {Fee}</h3>
                                <h4 style={{ textAlign: 'left', padding: '0 30px' }}>Details</h4>
                                <ul style={{ textAlign: 'left' }}>
                                    <li>Only for MBBS/BDS under graduate student , membership will valid upto  Internship .</li>
                                    <li>Applicant will be Associate member till you apply for life membership and rule of same will apply.</li>
                                    <li>After expiry of Student membership,  if applicant  will apply for life membership  within 6 month of internship completion, fees will be Rs. 1135/- (Rs. 1000/- plus charges). Otherwise full life membership fees Rs. 1635/- (Rs. 1500/- plus charges).</li>
                                    <li>Membership Fee = ₹ {stfee==='student'?400:stfee==='single'?1000 :Fee }</li>
                                    <li>Online Payment Service fee of 2% on the Total</li>
                                    <li>GST on Service fee</li>
                                    <li>E-Certificate shall be sent on the provided email address.</li>
                                    <li>Hard Copy shall be sent via Courier/Speed Post.</li>
                                    <li>Pack + Courier Fee – ₹ {stfee==='student'?92:95} (Pan India – maximum fee)</li>
                                </ul>
                                <button className="registerBtn" onClick={handleRegister}>Register Yourself</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

    )
}



export default StudentPayment
